module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_j_leucistic.abb2a3cc.png";